const gratishpConstants={
  FILESIZE:2097152,
  NOT_FOUND_IMAGE:'https://portadas.oupe.es/default.png'  
}
export default gratishpConstants